<template>
  <p>
    Integra y gestiona tus conectores de API para tus IVR operadores automáticos y chatbots de WhatsApp.
  </p>

  <a-form class="filters__form" layout="vertical" :model="formState">
    <a-form-item name="name">
      <a-input
        v-model:value="formState.name"
        placeholder="Buscar por nombre del conector"
        class="filters__input__large"
        @change="fetchConnectorList"
      >
        <template #prefix>
          <SearchOutlined />
        </template>
      </a-input>
    </a-form-item>
  </a-form>

  <CustomScrollbar height="calc(100% - 80px)" style="margin: 0">
    <ConnectorList :connectorList="connectorList" :loading="loading" @update="fetchConnectorList" />
  </CustomScrollbar>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from "vue";
import { SearchOutlined } from "@ant-design/icons-vue";
import { useRoute } from "vue-router";

import { Connector, ConnectorFilters } from "@/@types/ivr";
import { connectorServices } from "@/app/ivr/bot/services/ConnectorServices";

import ConnectorList from "@/app/ivr/bot/components/lists/ConnectorList.vue";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import { ConnectionType } from "../../utils/enums";

const route = useRoute();

const formState = reactive<Filters>({
  name: "",
  status: "",
});

const loading = ref(false);
const connectorList = ref<Connector[]>([]);

const fetchConnectorList = async () => {
  try {
    loading.value = true;
    connectorList.value = await connectorServices.getList(formState);
    connectorList.value = connectorList.value.map((conector) => {
      const ivrs = conector.ivr?.map(el => ({ ...el, type: ConnectionType.Ivr })) || [];
      const bots = conector.bot?.map(el => ({ ...el, type: ConnectionType.Chatbot })) || [];
      return { 
        ...conector,
        connections: [...ivrs, ...bots]
      }
    });

    console.log(connectorList.value, 'connectorList');
      
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
};

onMounted(async () => {
  await fetchConnectorList();
});
</script>

<style scoped lang="sass">
p
  margin: 0

.ant-form-item
  margin: 0

.filters
  &__form
    display: flex
    gap: 8px
    margin: 20px 0

  &__input
    min-width: 180px

    &__large
      min-width: 260px
</style>
